<template>
  <div class="form-closed-wrapper">
    <div class="form-closed-box">
      <div class="form-closed-top-bar"></div>
      <div class="form-closed-content">
        <h2 class="form-closed-title">{{title}}</h2> 
        <div v-if="description">
          <p class="form-closed-text">{{ description }}</p>
        </div>
        <div v-else-if="startStamp != 0">
          <p class="form-closed-text">This form will start accepting responses on</p>
          <p class="form-closed-date">{{ formatTimestamp2(startStamp).formattedDate }}</p>
          <p class="form-closed-days">{{ formatTimestamp2(startStamp).timeString}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTimestamp2 } from './ComFun'

export default {
  name: 'FormClosed',
  props: {
    title: String,
    description: String,
    startStamp: Number
  },
  methods: {
    formatTimestamp2
  }
}
</script>

<style scoped>
.form-closed-wrapper {
  background-color: #f3effd;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  font-family: Google Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.form-closed-box {
  align-self: flex-start;
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 1px 3px rgba(60, 64, 67, 0.3);
  overflow: hidden;
}

.form-closed-top-bar {
  height: 10px;
  background-color: #673ab7; /* Google 紫色 */
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.form-closed-content {
  padding: 24px;
  color: #212529;
}

.form-closed-title {
  font-size: 1.5625rem;
  font-weight: 400;
  margin-bottom: 20px;
}

.form-closed-text {
  font-size: 1rem;
  margin-bottom: 9px;
}

.form-closed-date {
  font-size: 1.25rem;
}

.form-closed-days {
  font-size: 1.25rem;
  margin-top: 9px;
}
</style>
